/**
 * Checks whether an API response or HTTP error represents a 403 Forbidden / Access Denied state.
 * @param {object} [res] - The parsed API DTO response (e.g., { code: 403, error: 'Forbidden' }).
 * @param {object} [err] - The caught HTTP exception object (e.g., err.response.status === 403).
 * @returns {boolean} True if the error is a 403 Forbidden / Access Denied error.
 */
export const isForbiddenError = (res, err) => {
  if (err?.response?.status === 403 || err?.status === 403) {
    return true;
  }
  if (!res) return false;
  return (
    res.code === 403 ||
    res.status === 403 ||
    res.error === 'Forbidden' ||
    (typeof res.error === 'string' && res.error.includes('403')) ||
    (typeof res.description === 'string' && res.description.includes('403'))
  );
};

/**
 * Checks whether an API response or HTTP error represents a 404 Not Found state.
 * @param {object} [res] - The parsed API DTO response (e.g., { code: 404, error: 'Not Found' }).
 * @param {object} [err] - The caught HTTP exception object (e.g., err.response.status === 404).
 * @returns {boolean} True if the error is a 404 Not Found error.
 */
export const isNotFoundError = (res, err) => {
  if (err?.response?.status === 404 || err?.status === 404) {
    return true;
  }
  if (!res) return false;
  return (
    res.code === 404 ||
    res.status === 404 ||
    res.error === 'NotFound' ||
    res.error === 'Not Found' ||
    (typeof res.error === 'string' && res.error.includes('404')) ||
    (typeof res.description === 'string' && res.description.includes('404'))
  );
};
